import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE } from 'constants/message-type.constants';
import { FetchAndSyncAchievementUpdatesResponse } from 'types/response.types';

export const fetchAndSyncAchievementUpdates =
  (): Promise<FetchAndSyncAchievementUpdatesResponse> =>
    SocketAsFetch.fetch({
      message_type: FETCH_AND_SYNC_ACHIEVEMENTS_UPDATES_MESSAGE_TYPE,
    });
